import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useCreateContactUs = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("ContactUs/CreateContactUs", formData);
  });
  return mutation;
};
export default useCreateContactUs;
